export default {
  name: "Inc137",
  props: {
    bottomVal: {
      type: Number,
      default: () => 0
    }
  }
};